import { useCallback } from 'react';

import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
import { useAppSelector } from 'redux/reduxHooks';
import { POST_MESSAGE_ACTION } from 'utils/constants/common';

const useNotifyBookingCompleted = () => {
  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const bookingSuccessRedirectUrl = useAppSelector(
    (state) => state.clinicDetailsSlice.clinicData.bookingSuccessRedirectUrl
  );

  const isRedirectEnabled = isLoadedInsideIframe && !!bookingSuccessRedirectUrl;

  const onBookingCompleted = useCallback(() => {
    if (!isRedirectEnabled) {
      return false;
    }

    window.parent.postMessage(
      { event: POST_MESSAGE_ACTION.BOOKING_COMPLETED },
      '*'
    );
  }, [isRedirectEnabled]);

  return { isRedirectEnabled, onBookingCompleted };
};

export default useNotifyBookingCompleted;
